'use es6';

import { createSelector } from 'reselect';
import { getPreviewTextWidget } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
export const getPreviewTextModuleExists = createSelector([getPreviewTextWidget], widget => widget !== undefined && widget !== null);
export const getPreviewText = createSelector([getPreviewTextModuleExists, getPreviewTextWidget], (previewTextModuleExists, widget) => previewTextModuleExists && widget ? widget.getIn(['body', 'value']) : '');